import type { Meeting } from '../../types';
import { t } from '../../lib/i18n';

export type BotTone = 'pending' | 'live' | 'working' | 'done' | 'failed';

/** Skribby ham durumu (ve bizim ara durumlarımız) → kullanıcıya gösterilen etiket. */
export function botStatusLabel(bot: NonNullable<Meeting['bot']>): { label: string; tone: BotTone } {
  switch (bot.status) {
    case 'creating':
    case 'scheduled':
      return { label: t('Bot planlandı', 'Bot scheduled'), tone: 'pending' };
    case 'booting':
    case 'joining':
      return { label: t('Bot katılıyor', 'Bot joining'), tone: 'pending' };
    case 'waiting_to_record':
    case 'breakout_waiting_room':
      return { label: t('Bot bekleme odasında', 'Bot in waiting room'), tone: 'pending' };
    case 'recording':
      return { label: t('Bot kayıtta', 'Bot recording'), tone: 'live' };
    case 'processing':
    case 'transcribing':
    case 'leaving':
    case 'finished':
      return { label: t('Transkript hazırlanıyor', 'Preparing transcript'), tone: 'working' };
    case 'summarizing':
      return { label: t('Özetleniyor', 'Summarizing'), tone: 'working' };
    case 'completed':
      return { label: t('Bot kaydı', 'Bot recording'), tone: 'done' };
    default:
      return { label: t('Bot başarısız', 'Bot failed'), tone: 'failed' };
  }
}

export const BOT_TONE_CLASS: Record<BotTone, string> = {
  pending: 'bg-amber-500/15 text-amber-400 border-amber-500/30',
  live: 'bg-rose-500/15 text-rose-400 border-rose-500/30',
  working: 'bg-[#3AC8E0]/15 text-[#46CBE2] border-[#3AC8E0]/30',
  done: 'bg-neutral-500/15 text-neutral-400 border-neutral-500/30',
  failed: 'bg-rose-500/15 text-rose-400 border-rose-500/30',
};

/** Bot hâlâ toplantıda mı (durdurulabilir mi). */
export function isBotActive(bot: Meeting['bot']): boolean {
  if (!bot) return false;
  return ['scheduled', 'booting', 'joining', 'waiting_to_record', 'breakout_waiting_room', 'recording'].includes(
    bot.status
  );
}
